<template>
  <div class="root">
    <div class="image-container">
      <img :src="classroom.avatar" class="image" />
      <div class="title">{{ classroom.name }}</div>
    </div>
    <div class="description-container">
      <div class="title">Introduction</div>
      <div class="content">{{ classroom.description }}</div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { getClassroomById } from "@/api";

export default {
  name: "ClassroomInfo",
  data() {
    return {
      classroom: {
        name: "",
        avatar: "",
        description: ""
      }
    };
  },
  mounted() {
    this.getClassInfo();
  },
  methods: {
    ...mapMutations(["setCurrentClass"]),
    getClassInfo() {
      getClassroomById(this.$route.params.class_id).then(res => {
        this.classroom = {
          name: res.name,
          avatar: res.avatar,
          description: res.description
        };
        this.setCurrentClass(res);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.root {
  width: 80%;
  margin: auto;
}
.image-container {
  margin-top: 12px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  .image {
    width: 100%;
    display: block;
  }
  .title {
    position: absolute;
    top: 0px;
    left: 0px;
    margin: 30px;
    color: white;
    font-size: 32px;
  }
}
.description-container {
  background-color: #00897b;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 24px;
  position: relative;
  .title {
    position: absolute;
    top: 0px;
    left: 0px;
    margin: 30px;
    color: white;
    font-size: 26px;
  }
  .content {
    color: white;
    margin: 72px 30px 32px 30px;
  }
}
</style>